import Alerts from './Alerts';
import alertsStore, { AlertsStore } from './redux';

export { alertsStore };
export type { AlertsStore };
export default Alerts;
